import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { FormValue } from '@fcom/service-forms/interfaces';

export enum RefundFormPurchaseChannels {
  FINNAIR = 'finnair',
  OTHER = 'other',
}

export enum RefundFormRefundReasons {
  FLIGHT_CANCELLED_BY_FINNAIR = 'flightCancelledByFinnair',
  CANCELLED_WITHIN_24_HOURS = 'flightCancelledWithin24Hours',
  EXTRA_NOT_DELIVERED = 'extraNotDelivered',
  CHANGED_FLIGHT_OR_SEAT = 'changedFlightOrSeat',
  CANCELLED_BY_TICKET_RULES = 'ticketAllowsCancellation',
  FAULTY_PRODUCT = 'faultyProduct',
  BEST_BEFORE_EXPIRE = 'bestBeforeExpire',
  WRONG_PRODUCT = 'wrongProduct',
  CANCELLED_MYFLIGHT = 'cancelledMyFlight',
  ORDER_NOT_DELIVERED = 'orderNotDelivered',
}

export enum RefundPaymentMethods {
  MONEY_BACK = 'moneyBack',
  GIFT_VOUCHER = 'giftVoucher',
}

export enum RefundTypes {
  FLIGHT = 'flight',
  EXTRAS = 'extras',
  FLIGHT_AND_EXTRAS = 'flightAndExtras',
}

export enum RefundPaymentTypes {
  ONLINE_BANK = 'onlineBank',
  OTHER = 'other',
}

export enum RefundFormOnlineBankFields {
  IBAN = 'iban',
  ACCOUNT_NUMBER = 'accountNumber',
  BIC = 'bic',
  ACCOUNT_HOLDER = 'accountHolder',
  ACCOUNT_HOLDER_ADDRESS = 'accountHolderAddress',
  BANK_NAME = 'bankName',
  BANK_ADDRESS = 'bankAddress',
  BANK_COUNTRY = 'country',
  NCC = 'ncc',
  IFSC = 'ifsc',
  BIK = 'bik',
  CBD = 'correspondentBankData',
  KPP = 'kpp',
  INN = 'inn',
  PATRONYMIC_NAME = 'patronymicName',
}

export enum RefundFormTravelExtraTypes {
  BAGGAGE = 'baggage',
  INTERNET = 'internet',
  LOUNGE = 'lounge',
  COMFORT_ITEMS = 'comfortItems',
  MEALS = 'meal',
  SEAT = 'seat',
  SEAT_AND_MEAL = 'seatAndMeal',
}

export enum RefundFormCountries {
  FINLAND = 'FI',
  ESTONIA = 'EE',
  SWEDEN = 'SE',
  UK = 'GB',
  RUSSIA = 'RU',
  AUSTRALIA = 'AU',
  CANADA = 'CA',
  USA = 'US',
  INDIA = 'IN',
  AUSTRIA = 'AT',
  BELGIUM = 'BE',
  CZECH_REPUBLIC = 'CZ',
  DENMARK = 'DK',
  FRANCE = 'FR',
  GERMANY = 'DE',
  HUNGARY = 'HU',
  ICELAND = 'IS',
  IRELAND = 'IE',
  ITALY = 'IT',
  LATVIA = 'LV',
  LITHUANIA = 'LT',
  NETHERLANDS = 'NL',
  NORWAY = 'NO',
  POLAND = 'PL',
  PORTUGAL = 'PT',
  SPAIN = 'ES',
  SWITZERLAND = 'CH',
  CHINA = 'CN',
  HONGKONG = 'HK',
  ISRAEL = 'IL',
  JAPAN = 'JP',
  KOREA = 'KR',
  SINGAPORE = 'SG',
  THAILAND = 'TH',
  OTHER_COUNTRIES = 'OTHER',
}

export const OnlineBankFields = [
  RefundFormOnlineBankFields.IBAN,
  RefundFormOnlineBankFields.BIC,
  RefundFormOnlineBankFields.BANK_NAME,
  RefundFormOnlineBankFields.BANK_ADDRESS,
  RefundFormOnlineBankFields.ACCOUNT_HOLDER,
  RefundFormOnlineBankFields.ACCOUNT_HOLDER_ADDRESS,
  RefundFormOnlineBankFields.ACCOUNT_NUMBER,
  RefundFormOnlineBankFields.NCC,
  RefundFormOnlineBankFields.IFSC,
  RefundFormOnlineBankFields.BIK,
  RefundFormOnlineBankFields.CBD,
  RefundFormOnlineBankFields.KPP,
  RefundFormOnlineBankFields.INN,
  RefundFormOnlineBankFields.PATRONYMIC_NAME,
];

export const IbanCountries = [
  RefundFormCountries.FINLAND,
  RefundFormCountries.ESTONIA,
  RefundFormCountries.SWEDEN,
  RefundFormCountries.UK,
  RefundFormCountries.AUSTRIA,
  RefundFormCountries.BELGIUM,
  RefundFormCountries.CZECH_REPUBLIC,
  RefundFormCountries.DENMARK,
  RefundFormCountries.FRANCE,
  RefundFormCountries.GERMANY,
  RefundFormCountries.HUNGARY,
  RefundFormCountries.ICELAND,
  RefundFormCountries.IRELAND,
  RefundFormCountries.ITALY,
  RefundFormCountries.LATVIA,
  RefundFormCountries.LITHUANIA,
  RefundFormCountries.NETHERLANDS,
  RefundFormCountries.NORWAY,
  RefundFormCountries.POLAND,
  RefundFormCountries.PORTUGAL,
  RefundFormCountries.SPAIN,
  RefundFormCountries.SWITZERLAND,
  RefundFormCountries.ISRAEL,
];

export const EnabledOnlineBankFields = [
  {
    name: RefundFormOnlineBankFields.IBAN,
    enabledCountries: IbanCountries,
  },
  {
    name: RefundFormOnlineBankFields.ACCOUNT_NUMBER,
    enabledCountries: [
      RefundFormCountries.RUSSIA,
      RefundFormCountries.AUSTRALIA,
      RefundFormCountries.CANADA,
      RefundFormCountries.USA,
      RefundFormCountries.INDIA,
      RefundFormCountries.CHINA,
      RefundFormCountries.HONGKONG,
      RefundFormCountries.JAPAN,
      RefundFormCountries.KOREA,
      RefundFormCountries.SINGAPORE,
      RefundFormCountries.THAILAND,
      RefundFormCountries.OTHER_COUNTRIES,
    ],
  },
  {
    name: RefundFormOnlineBankFields.BIC,
    enabledCountries: [
      RefundFormCountries.AUSTRALIA,
      RefundFormCountries.CANADA,
      RefundFormCountries.USA,
      RefundFormCountries.UK,
      RefundFormCountries.RUSSIA,
      RefundFormCountries.CHINA,
      RefundFormCountries.HONGKONG,
      RefundFormCountries.ISRAEL,
      RefundFormCountries.JAPAN,
      RefundFormCountries.KOREA,
      RefundFormCountries.SINGAPORE,
      RefundFormCountries.THAILAND,
      RefundFormCountries.OTHER_COUNTRIES,
    ],
  },
  {
    name: RefundFormOnlineBankFields.ACCOUNT_HOLDER,
    enabledCountries: ['ALL'],
  },
  {
    name: RefundFormOnlineBankFields.ACCOUNT_HOLDER_ADDRESS,
    enabledCountries: [
      RefundFormCountries.RUSSIA,
      RefundFormCountries.AUSTRALIA,
      RefundFormCountries.CANADA,
      RefundFormCountries.USA,
      RefundFormCountries.INDIA,
      RefundFormCountries.CHINA,
      RefundFormCountries.HONGKONG,
      RefundFormCountries.ISRAEL,
      RefundFormCountries.JAPAN,
      RefundFormCountries.KOREA,
      RefundFormCountries.SINGAPORE,
      RefundFormCountries.THAILAND,
      RefundFormCountries.OTHER_COUNTRIES,
    ],
  },
  {
    name: RefundFormOnlineBankFields.BANK_NAME,
    enabledCountries: [
      RefundFormCountries.RUSSIA,
      RefundFormCountries.AUSTRALIA,
      RefundFormCountries.CANADA,
      RefundFormCountries.USA,
      RefundFormCountries.INDIA,
      RefundFormCountries.CHINA,
      RefundFormCountries.HONGKONG,
      RefundFormCountries.ISRAEL,
      RefundFormCountries.JAPAN,
      RefundFormCountries.KOREA,
      RefundFormCountries.SINGAPORE,
      RefundFormCountries.THAILAND,
      RefundFormCountries.OTHER_COUNTRIES,
    ],
  },
  {
    name: RefundFormOnlineBankFields.BANK_ADDRESS,
    enabledCountries: [
      RefundFormCountries.RUSSIA,
      RefundFormCountries.AUSTRALIA,
      RefundFormCountries.CANADA,
      RefundFormCountries.USA,
      RefundFormCountries.INDIA,
      RefundFormCountries.CHINA,
      RefundFormCountries.HONGKONG,
      RefundFormCountries.ISRAEL,
      RefundFormCountries.JAPAN,
      RefundFormCountries.KOREA,
      RefundFormCountries.SINGAPORE,
      RefundFormCountries.THAILAND,
      RefundFormCountries.OTHER_COUNTRIES,
    ],
  },
  {
    name: RefundFormOnlineBankFields.NCC,
    enabledCountries: [RefundFormCountries.AUSTRALIA, RefundFormCountries.USA, RefundFormCountries.CANADA],
  },
  {
    name: RefundFormOnlineBankFields.IFSC,
    enabledCountries: [RefundFormCountries.INDIA],
  },
  {
    name: RefundFormOnlineBankFields.BIK,
    enabledCountries: [RefundFormCountries.RUSSIA],
  },
  {
    name: RefundFormOnlineBankFields.CBD,
    enabledCountries: [RefundFormCountries.RUSSIA],
  },
  {
    name: RefundFormOnlineBankFields.KPP,
    enabledCountries: [RefundFormCountries.RUSSIA],
  },
  {
    name: RefundFormOnlineBankFields.INN,
    enabledCountries: [RefundFormCountries.RUSSIA],
  },
  {
    name: RefundFormOnlineBankFields.PATRONYMIC_NAME,
    enabledCountries: [RefundFormCountries.RUSSIA],
  },
];

export type RefundForm = {
  purchaseChannel: FormControl<RefundFormPurchaseChannels>;
  refundType: FormControl<RefundTypes>;
  refundReason: FormControl<RefundFormRefundReasons>;
  reservationNumber: FormControl<string>;
  flightNumber: FormControl<string>;
  flightDate: FormControl<string>;
  bookingDate: FormControl<string>;
  cancellationDate: FormControl<string>;
  phoneNumber: FormControl<string>;
  email: FormControl<string>;
  passengers: FormArray<FormGroup<RefundFormPassengers>>;
  paymentMethod: FormControl<RefundPaymentMethods>;
  paymentType: FormControl<RefundPaymentTypes>;
  iban: FormControl<string>;
  bic: FormControl<string>;
  accountHolder: FormControl<string>;
  accountHolderAddress: FormControl<string>;
  bankName: FormControl<string>;
  bankAddress: FormControl<string>;
  additionalInformation: FormControl<string>;
  country: FormControl<string>;
  accountNumber: FormControl<string>;
  ncc: FormControl<string>;
  ifsc: FormControl<string>;
  bik: FormControl<string>;
  correspondentBankData: FormControl<string>;
  kpp: FormControl<string>;
  inn: FormControl<string>;
  patronymicName: FormControl<string>;
};

export type RefundFormPassengers = {
  firstname: FormControl<string>;
  lastname: FormControl<string>;
  finnairPlusNumber: FormControl<string>;
  ticketNumber: FormControl<string>;
  travelExtras: FormArray<FormGroup<RefundFormPassengersTravelExtras>>;
  preorderBagNumber: FormControl<string>;
};

export type RefundFormPassengersTravelExtras = {
  emdNumber: FormControl<string>;
  refundItemType: FormControl<string>;
};

export type RefundFormData = FormValue<FormGroup<RefundForm>>;
